import { NodeTag } from '../logic/GameState';

let nextTag = 0;
export default function getTag(): NodeTag {
    return (nextTag++).toString() as NodeTag;
}
